/**
   * @ngdoc directive
   * @name adjust.directive:scrollSide
   * @scope
   * @restrict A
   *
   * @description
   * Scroll side which is child of the {@link adjust.directive:scroll scroll} container directive
   *
   */
function scrollSide(Helper) {
  'ngInject';
  return {
    restrict: 'A',
    scope: {},
    require: ['scrollSide', '^scroll'],
    controller: 'ScrollSideController',
    link: Helper.linkFunction
  };
}

/**
   * @ngdoc controller
   * @name adjust.controller:ScrollSideController
   *
   * @description
   * All the functionality of the {@link adjust.directive:scrollSide scrollBar} directive
   *
   */
function ScrollSideController($element) {
  'ngInject';
  var vm = this;

  vm.init = init;

  /**
   * @ngdoc method
   * @name init
   * @methodOf adjust.controller:ScrollSideController
   *
   * @description
   * Register parent controller and make side list element available in parent
   *
   * @param {Object} parentController parent controller
   *
   */
  function init(parentController) {

    vm.parentController = parentController;

    vm.parentController.setSide($element[0]);

  }
}

export { ScrollSideController, scrollSide };
